var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ActionDropdownViewModel } from "survey-core";
import { ReactElementFactory } from "../../element-factory";
import { Popup } from "../popup/popup";
import { SurveyActionBarItem } from "./action-bar-item";
var SurveyActionBarItemDropdown = /** @class */ (function (_super) {
    __extends(SurveyActionBarItemDropdown, _super);
    function SurveyActionBarItemDropdown(props) {
        return _super.call(this, props) || this;
    }
    SurveyActionBarItemDropdown.prototype.renderInnerButton = function () {
        var button = _super.prototype.renderInnerButton.call(this);
        return (React.createElement(React.Fragment, null,
            button,
            React.createElement(Popup, { model: this.item.popupModel })));
    };
    SurveyActionBarItemDropdown.prototype.componentDidMount = function () {
        this.viewModel = new ActionDropdownViewModel(this.item);
    };
    SurveyActionBarItemDropdown.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.viewModel.dispose();
    };
    return SurveyActionBarItemDropdown;
}(SurveyActionBarItem));
export { SurveyActionBarItemDropdown };
ReactElementFactory.Instance.registerElement("sv-action-bar-item-dropdown", function (props) {
    return React.createElement(SurveyActionBarItemDropdown, props);
});
